import { defineStore } from 'pinia'

const useDiscountStore = defineStore('discount', {
  state: () => ({
    // add initial state here
  }),
  actions: {
    // add actions here
  },
})

export default useDiscountStore
